import React from 'react';

var defaultValue = {
    control: 'none',
    setControl: function () { },
};
var Context = React.createContext(defaultValue);
function FormControlContextProvider(_a) {
    var children = _a.children;
    var _b = React.useState(defaultValue.control), control = _b[0], setControl = _b[1];
    return (React.createElement(Context.Provider, { value: { control: control, setControl: setControl } }, children));
}
var useFormControlContext = function () { return React.useContext(Context); };

export { FormControlContextProvider as F, useFormControlContext as u };
